import React, { useReducer, createContext } from "react";
import { contentReducer, contentInitialState } from "../reducers";
import constant from "../constants/contentConstant";
import { contentService } from "../services";
import { history } from "../tools";
import { toast } from "react-toastify"

export const ContentContext = createContext();

export const ContentContextProvider = (props) => {

    const [state, dispatch] = useReducer(contentReducer, contentInitialState);

    const search = (key) => {

        dispatch(request());

        contentService.search(key).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("the content couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.SEARCH_SUCCESS, payload: data }; }
        function fail() { return { type: constant.SEARCH_FAIL }; }
        function request() { return { type: constant.SEARCH_REQUEST }; }
    };

    const paginate = (dto) => {

        dispatch(request());

        contentService.paginate(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("contents couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.PAGINATE_SUCCESS, payload: data }; }
        function fail() { return { type: constant.PAGINATE_FAIL }; }
        function request() { return { type: constant.PAGINATE_REQUEST }; }
    };

    const goToDetail = (data) => {

        history.push("/" + data.kind + "/" + data.id)
    }

    return (
        <ContentContext.Provider value={[state, { search, paginate, goToDetail }]}>
            {props.children}
        </ContentContext.Provider>
    );
};

